import { GoogleDriveIcon } from './GoogleDriveIcon';

/**
 * author: Google
 * id EE98C0AD-0A55-4A6B-BB7A-01CBD3D819A2
 * name google-drive
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/google-drive.svg
 * tags
 * - Brand / Logo 
 */
export const AttachDriveIcon = GoogleDriveIcon;
export default AttachDriveIcon